module.exports = __webpack_public_path__ + "img/arrow_next_black.b4da7f70.svg";